'use client';

import type { SubQuestionType } from '~/model/SubQuestionType';

export const StarRatingResult = ({
  resultId,
  resultData,
  subQuestions,
}: StarRatingResultPropsType) => {
  return (
    <div className="results__items" data-testid="starRating">
      {resultData
        && resultData.map((item: Data, index: number) => {
          const { average } = item;
          const subquestion
            = subQuestions?.length > 0
              && subQuestions.find(q => q['@id'] === item['@id']).title;
          const roundedValue = average && Math.round(average);
          return (
            <div
              key={`star-rating-${resultId}-${index}`}
              className="results__item"
              data-cy="starResult"
            >
              <div className="results__label">{subquestion}</div>
              <div className="results__value" data-cy="result">
                <div
                  className="vtmn-rating vtmn-rating_variant--brand"
                  aria-label={`${average}/5`}
                  title={`${average}/5`}
                >
                  {Array.from({ length: 5 }, (_, i) => i + 1).map(
                    (value, index) => {
                      const cssClass
                        = value <= roundedValue
                          ? 'vtmx-star-fill'
                          : 'vtmx-star-line';
                      return (
                        <span
                          key={`star-${resultId}-${index}`}
                          className={cssClass}
                          role="presentation"
                        >
                        </span>
                      );
                    },
                  )}
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export interface StarRatingResultPropsType {
  resultId: number;
  resultData: Data[];
  subQuestions: SubQuestionType[];
}

interface Data {
  answers_count: number;
  answers_repartition: AnswersRepartitionType;
  subquestion: string;
  average: number;
}

interface AnswersRepartitionType {
  rating: number;
  count: number;
  percentage: number;
}
